import { axiosLevelTech } from '@/services/axiosConfig';
import { setNativeToken, clearNativeToken, initTokens } from './apiServiceCSRF';
import { useUserDataStore } from '@/store/userDataStore';

  async function login(email: string, password: string): Promise<any> {
    try {
      const response = await axiosLevelTech.post('api/login', {
        email,
        password,
      });
      console.log('response', response);
      if (response.data && response.data.token) {
        await setNativeToken(response.data.token);
      }
      await initTokens();
      await useUserDataStore().fetchUserData();
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async function logout(): Promise<any> {
    const userDataStore = useUserDataStore();
    try {
      const response = await axiosLevelTech.post('api/logout');
      console.log('response', response);
      await clearNativeToken();
      userDataStore.userInfo = null;
      await initTokens();
      await userDataStore.fetchUserData();
      return response;
    }
    catch (error) { return Promise.reject(error); }
  }

  async function forgotPassword(email: string): Promise<any> {
    try {
      const response = await axiosLevelTech.post('api/forgot-password', { email });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  export const authService = {
  login, logout, forgotPassword
};
